import APIKit from "../Allapis/Apikit/apikit";

export const getFstUsersList = async (params = {}) => {
  try {
    const { email, name } = params;
    const res = await APIKit.get("/admin/fst", { params: { email, name } });
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const createFstUser = async (body) => {
  try {
    const res = await APIKit.post("/admin/fst", body);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const changeFstUserPassword = async (id, body) => {
  try {
    const res = await APIKit.put(`/admin/fst/${id}/password`, body);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const inactivateFstUser = async (id) => {
  try {
    const res = await APIKit.put(`/admin/fst/${id}/inactive`);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};
